module.exports = __webpack_public_path__ + "img/domainss.dddc341.svg";